import { isNonZero } from '@nora-monorepo/shared';

export function hexToRgb(color: string): { r: number; g: number; b: number } | null {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
  if (!result) {
    return null;
  }
  return {
    r: Number.parseInt(result[1] ?? '0', 16),
    g: Number.parseInt(result[2] ?? '0', 16),
    b: Number.parseInt(result[3] ?? '0', 16),
  };
}

export function colorWithOpacity(color: string, opacity?: number): string {
  if (!isNonZero(opacity)) {
    return color;
  }

  const parsedHexColor = hexToRgb(color);
  if (parsedHexColor) {
    const { r, g, b } = parsedHexColor;
    if (r === undefined || g === undefined || b === undefined) {
      return color;
    }
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  if (color.startsWith('rgb')) {
    return color.replace('rgb', 'rgba').replace(')', `, ${opacity})`);
  }

  return color;
}
